import React from "react";
import "./CustomAlert.css";

const CustomAlert = ({ type = "info", message, onClose }) => {
  if (!message) return null;

  return (
    <div className={`custom-alert ${type}`}>
      <span className="alert-text">{message}</span>
      <button className="alert-close" onClick={onClose}>×</button>
    </div>
  );
};

export default CustomAlert;
